import axios from 'axios'
import { getCookie, removeCookie } from './auth'

const service = axios.create(
  {
    baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/api/' : window.location.origin + '/api/',
    timeout: process.env.NODE_ENV === 'development' ? 0 : 15000,
    withCredentials: true
  })

service.interceptors.request.use(
  async config => {
    config.headers.post['Content-Type'] = 'application/json multipart/form-data'
    if (getCookie('tokenGrupTakip')) {
      config.headers.common.Authorization = 'Bearer ' + getCookie('tokenGrupTakip')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.config.url === 'rapor/excelOgrenciRapor' || response.config.url === 'rapor/excelSinifRapor' ||
            response.config.url === 'rapor/excelKisiRapor') {
      return Promise.resolve(response)
    } else {
      return Promise.resolve(response.data)
    }
  },
  async error => {
    if (error.response) {
      const { status: statusKod } = error.response
      if (statusKod === 401) {
        Sil()
        location.reload()
      } else if (statusKod === 400) {
        if (error.response && error.response.data && error.response.data.message) {
          window.lokum.$bvToast.toast(error.response.data.message, {
            title: 'Hata',
            autoHideDelay: 5000,
            variant: 'danger',
            solid: true
          })
        }
      }
    } else {
      window.lokum.$bvToast.toast('İletişim Hatası Oluştu', {
        title: 'Hata',
        autoHideDelay: 5000,
        variant: 'danger',
        solid: true
      })
    }
    return Promise.reject(error.response)
  }
)

function Sil () {
  removeCookie('tokenGrupTakip')
}

export default service
